import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-industry-animate',
  templateUrl: './industry-animate.component.html',
  styleUrls: ['./industry-animate.component.css']
})
export class IndustryAnimateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/login/industry-animate/industry-animate.component.ts